import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
// eslint-disable-next-line
import { FormInputErrorItem } from '@mwe/models';
import { ErrorType } from '../../voucher/new-voucher.util';

/**
 * This function maps errors to a custom error key.
 * For example, mapErrorKey(trimmedMinLength(1), 'trimmedMinLength') would map (if invalid) { equal: true } to { trimmedMinLength: false }.
 *
 * @param validator to be used.
 * @param errorKey to be mapped to.
 * @returns error with mapped error key if it exists, otherwise null.
 */
export function mapErrorKey(validator: ValidatorFn, errorKey: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => (validator(control) ? { [errorKey]: true } : null);
}

/**
 * This function maps errors from IL to an error item array for <mwe-form>.
 * This can be used to display specific errors depending on what response came from IL.
 *
 * @param errors as a Record when an ILErrorCode maps to the error string to be displayed.
 * @returns error items array for FormComponent if any exist, otherwise [].
 */
export function mapToErrorItems(errors: Record<ErrorType, string>): FormInputErrorItem[] {
  return Object.entries(errors).map(([errorType, errorValue]) => mapToErrorItem(errorType, errorValue));
}

function mapToErrorItem(key: ErrorType, label: string): FormInputErrorItem {
  return { key: key.toString(), label };
}
